// import React, { useState, useEffect } from 'react';
// import { Search, Loader2, Eye, X, BookOpen, Calendar, User, FileText, CheckCircle2, Download } from 'lucide-react';
// import * as XLSX from 'xlsx';


// export default function CiaAcknowledgementsList() {
//   const [dataList, setDataList] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [tableLoading, setTableLoading] = useState(false);
//   const [selectedAck, setSelectedAck] = useState(null); // For detail view modal

//   // Pagination Controls
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 8;

//   useEffect(() => {
//     fetchAcknowledgements();
//   }, [searchTerm]);

//   const fetchAcknowledgements = async () => {
//     setTableLoading(true);
//     try {
//       const res = await fetch(
//         `https://metapi.emedhatechnologies.com/api/exams/cia-acknowledgements?search=${encodeURIComponent(searchTerm)}`
//       );
//       const result = await res.json();
//       if (result.success) setDataList(result.data);
//       else setDataList([]);
//     } catch (err) {
//       console.error('Failed to load CIA acknowledgements:', err);
//       setDataList([]);
//     } finally {
//       setTableLoading(false);
//     }
//   };

//   // Pagination Window Range Computation
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = dataList.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(dataList.length / itemsPerPage);

//   const formatDate = (dateStr) => {
//     if (!dateStr) return '-';
//     const d = new Date(dateStr);
//     return isNaN(d.getTime()) ? dateStr : d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
//   };


//   const handleExportToExcel = () => {
//   if (dataList.length === 0) {
//     alert("No CIA acknowledgement records available to export.");
//     return;
//   }

//   const exportData = dataList.map((item, index) => ({
//     "S.No": index + 1,
//     "Record ID": `#${item.id}`,
//     "Enrolment Number": item.enrolment_number || 'N/A',
//     "Candidate Name": item.candidate_name || 'N/A',
//     "Course Stream": item.course_name || 'N/A',
//     "Course Code": item.course_code || 'N/A',
//     "Term / Semester": item.semester || 'Semester 1',
//     "Admission Year": item.year_of_admission || 'N/A',
//     "No of Papers Submitted": item.no_of_papers_submitted || (item.papers_list ? item.papers_list.length : 0),
//     "Submission Date": item.submission_date || (item.created_at ? new Date(item.created_at).toLocaleDateString('en-IN') : 'N/A'),
//     "Status": item.status || 'Submitted',
//     "Remarks": item.remarks || 'N/A'
//   }));

//   const worksheet = XLSX.utils.json_to_sheet(exportData);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "CIA_Acknowledgements");

//   const fileName = `CIA_Acknowledgements_Report_${new Date().toISOString().substring(0, 10)}.xlsx`;
//   XLSX.writeFile(workbook, fileName);
// };



//   return (
//     <div style={styles.container}>
//       {/* STEP 1: SEARCH FILTER BAR */}
// {/* STEP 1: SEARCH FILTER BAR & EXPORT DOCK */}
// <div style={styles.filterControlPanel}>
//   <div style={styles.searchWrapper}>
//     <Search size={16} style={styles.searchIcon} />
//     <input
//       type="text"
//       placeholder="Search by candidate, enrollment no, course, semester..."
//       value={searchTerm}
//       onChange={(e) => {
//         setSearchTerm(e.target.value);
//         setCurrentPage(1);
//       }}
//       style={styles.tableSearchInput}
//     />
//   </div>

//   <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//     <button
//       type="button"
//       onClick={handleExportToExcel}
//       style={styles.exportExcelBtn}
//       title="Export all filtered CIA acknowledgements to Excel"
//     >
//       <Download size={14} /> Export Excel
//     </button>

//     <div style={styles.totalIndicator}>
//       Total Acknowledgements: <strong style={{ color: '#1c6ec9' }}>{dataList.length}</strong>
//     </div>
//   </div>
// </div>

//       {/* STEP 2: DATA TABLE */}
//       {tableLoading ? (
//         <div style={{ display: 'flex', justifyContent: 'center', padding: '60px' }}>
//           <Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#1c6ec9" />
//         </div>
//       ) : (
//         <div style={{ overflowX: 'auto', width: '100%', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
//           <table style={styles.dataTable}>
//             <thead>
//               <tr>
//                 <th style={styles.tableTh}>Enrolment No</th>
//                 <th style={styles.tableTh}>Candidate Name</th>
//                 <th style={styles.tableTh}>Course Stream</th>
//                 <th style={styles.tableTh}>Course Code</th>
//                 <th style={styles.tableTh}>Term / Semester</th>
//                 <th style={styles.tableTh}>Admission Year</th>
//                 <th style={styles.tableTh}>Papers Submitted</th>
//                 <th style={styles.tableTh}>Submission Date</th>
//                 <th style={styles.tableTh}>Status</th>
//                 <th style={styles.tableTh}>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {dataList.length === 0 ? (
//                 <tr>
//                   <td colSpan="10" style={styles.noDataTd}>
//                     No CIA submission acknowledgements found matching your search.
//                   </td>
//                 </tr>
//               ) : (
//                 currentItems.map((item) => (
//                   <tr key={item.id} style={styles.tableTr}>
//                     <td style={{ ...styles.tableTd, fontWeight: '700', color: '#1e40af' }}>
//                       {item.enrolment_number}
//                     </td>
//                     <td style={{ ...styles.tableTd, fontWeight: '700', color: '#0f172a' }}>
//                       {item.candidate_name}
//                     </td>
//                     <td style={{ ...styles.tableTd, color: '#334155', fontWeight: '600' }}>
//                       {item.course_name}
//                     </td>
//                     <td style={{ ...styles.tableTd, color: '#64748b', fontWeight: '600' }}>
//                       {item.course_code}
//                     </td>
//                     <td style={styles.tableTd}>
//                       <span style={styles.termLabel}>{item.semester || 'Semester 1'}</span>
//                     </td>
//                     <td style={{ ...styles.tableTd, color: '#475569', fontSize: '13px' }}>
//                       {item.year_of_admission}
//                     </td>
//                     <td style={{ ...styles.tableTd, textAlign: 'center', fontWeight: '700', color: '#2563eb' }}>
//                       {item.no_of_papers_submitted || (item.papers_list ? item.papers_list.length : 0)} Papers
//                     </td>
//                     <td style={{ ...styles.tableTd, fontSize: '12.5px', color: '#475569' }}>
//                       {item.submission_date || formatDate(item.created_at)}
//                     </td>
//                     <td style={styles.tableTd}>
//                       <span
//                         style={{
//                           ...styles.statusPill,
//                           ...(item.status === 'Approved'
//                             ? styles.statusApproved
//                             : item.status === 'Verified'
//                             ? styles.statusVerified
//                             : styles.statusSubmitted),
//                         }}
//                       >
//                         {item.status || 'Submitted'}
//                       </span>
//                     </td>
//                     <td style={styles.tableTd}>
//                       <button
//                         onClick={() => setSelectedAck(item)}
//                         style={styles.viewRowBtn}
//                         title="View Full Acknowledgement"
//                       >
//                         <Eye size={13} style={{ marginRight: '4px' }} /> View
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* STEP 3: PAGINATION */}
//       {dataList.length > 0 && (
//         <div style={styles.paginationDock}>
//           <button
//             disabled={currentPage === 1}
//             onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//             style={currentPage === 1 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
//           >
//             Previous
//           </button>
//           <span style={styles.pageIndicator}>
//             Page <strong>{currentPage}</strong> of {totalPages || 1}
//           </span>
//           <button
//             disabled={currentPage === totalPages || totalPages === 0}
//             onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
//             style={
//               currentPage === totalPages || totalPages === 0
//                 ? { ...styles.pageBtn, ...styles.pageBtnDisabled }
//                 : styles.pageBtn
//             }
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {/* STEP 4: DETAILED ACKNOWLEDGEMENT VIEW MODAL */}
//       {selectedAck && (
//         <div style={styles.modalBackdrop}>
//           <div style={styles.modalWrapperCard}>
//             <div style={styles.modalHeader}>
//               <div>
//                 <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '800', color: '#0f172a' }}>
//                   CIA Submission Acknowledgement
//                 </h3>
//                 <span style={{ fontSize: '12px', color: '#64748b' }}>
//                   Record ID: #{selectedAck.id} • Submitted: {selectedAck.submission_date || formatDate(selectedAck.created_at)}
//                 </span>
//               </div>
//               <button onClick={() => setSelectedAck(null)} style={styles.modalCloseX}>
//                 <X size={18} />
//               </button>
//             </div>

//             <div style={styles.modalBodyScroll}>
//               {/* Candidate Info Grid Banner */}
//               <div style={styles.applicantInfoBanner}>
//                 <div style={styles.infoCol}>
//                   <span style={styles.infoLabel}>Candidate Name</span>
//                   <span style={styles.infoValue}>{selectedAck.candidate_name}</span>
//                 </div>
//                 <div style={styles.infoCol}>
//                   <span style={styles.infoLabel}>Enrolment Number</span>
//                   <span style={{ ...styles.infoValue, color: '#1e40af' }}>{selectedAck.enrolment_number}</span>
//                 </div>
//                 <div style={styles.infoCol}>
//                   <span style={styles.infoLabel}>Admission Year</span>
//                   <span style={styles.infoValue}>{selectedAck.year_of_admission}</span>
//                 </div>
//                 <div style={styles.infoCol}>
//                   <span style={styles.infoLabel}>Status</span>
//                   <span style={{ ...styles.infoValue, color: '#059669' }}>{selectedAck.status || 'Submitted'}</span>
//                 </div>
//               </div>

//               {/* Course Meta Banner */}
//               <div style={styles.courseMetaBar}>
//                 <div>
//                   <span style={{ fontSize: '11px', color: '#64748b', textTransform: 'uppercase', fontWeight: '700' }}>Course</span>
//                   <div style={{ fontSize: '14px', fontWeight: '800', color: '#0f172a' }}>
//                     {selectedAck.course_name} ({selectedAck.course_code})
//                   </div>
//                 </div>
//                 <div style={{ textAlign: 'right' }}>
//                   <span style={{ fontSize: '11px', color: '#64748b', textTransform: 'uppercase', fontWeight: '700' }}>Semester</span>
//                   <div style={{ fontSize: '13px', fontWeight: '700', color: '#1e40af' }}>
//                     {selectedAck.semester}
//                   </div>
//                 </div>
//               </div>

//               {/* Submitted Subject Papers Table */}
//               <div style={{ marginTop: '16px' }}>
//                 <span style={{ fontSize: '12px', fontWeight: '800', color: '#0f172a', textTransform: 'uppercase' }}>
//                   Submitted Papers ({selectedAck.papers_list ? selectedAck.papers_list.length : 0} Papers)
//                 </span>
//                 <div style={styles.subjectsTableWrapper}>
//                   <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                     <thead>
//                       <tr style={{ background: '#f1f5f9' }}>
//                         <th style={{ ...styles.subTh, width: '90px' }}>Sub Code</th>
//                         <th style={styles.subTh}>Title of the Course Paper</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {!selectedAck.papers_list || selectedAck.papers_list.length === 0 ? (
//                         <tr>
//                           <td colSpan="2" style={{ padding: '12px', textAlign: 'center', color: '#94a3b8', fontSize: '12px' }}>
//                             No papers list recorded.
//                           </td>
//                         </tr>
//                       ) : (
//                         selectedAck.papers_list.map((paper, idx) => (
//                           <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
//                             <td style={{ padding: '8px 12px', fontWeight: '700', color: '#2563eb', fontSize: '12.5px' }}>
//                               {paper.code}
//                             </td>
//                             <td style={{ padding: '8px 12px', color: '#334155', fontSize: '12.5px' }}>
//                               {paper.title}
//                             </td>
//                           </tr>
//                         ))
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               {/* Remarks Box */}
//               {selectedAck.remarks ? (
//                 <div style={styles.remarksBox}>
//                   <span style={styles.infoLabel}>Remarks</span>
//                   <div style={{ fontSize: '12.5px', color: '#334155', marginTop: '2px' }}>
//                     {selectedAck.remarks}
//                   </div>
//                 </div>
//               ) : null}

//               {/* Modal Footer Close Action */}
//               <div style={styles.modalActionDock}>
//                 <button onClick={() => setSelectedAck(null)} style={styles.modalCloseBtn}>
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// // STYLES MATRIX
// const styles = {
//   container: { width: '100%', boxSizing: 'border-box' },
//   filterControlPanel: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     gap: '16px',
//     marginBottom: '16px',
//     flexWrap: 'wrap',
//   },
//   searchWrapper: {
//     position: 'relative',
//     display: 'flex',
//     alignItems: 'center',
//     flex: 1,
//     maxWidth: '420px',
//     width: '100%',
//   },
//   searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
//   tableSearchInput: {
//     width: '100%',
//     padding: '10px 12px 10px 38px',
//     background: '#ffffff',
//     border: '1px solid #e2e8f0',
//     borderRadius: '10px',
//     color: '#0f172a',
//     fontSize: '13.5px',
//     outline: 'none',
//     boxShadow: '0 1px 2px rgba(0,0,0,0.02)',
//   },
//   totalIndicator: { fontSize: '13.5px', fontWeight: '600', color: '#475569' },
//   dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left', background: '#ffffff' },
//   tableTh: {
//     padding: '12px 14px',
//     borderBottom: '2px solid #e2e8f0',
//     background: '#f8fafc',
//     color: '#64748b',
//     fontSize: '11px',
//     textTransform: 'uppercase',
//     letterSpacing: '0.5px',
//     fontWeight: '700',
//     whiteSpace: 'nowrap',
//   },
//   tableTr: { borderBottom: '1px solid #f1f5f9' },
//   tableTd: { padding: '13px 14px', color: '#475569', fontSize: '13px', verticalAlign: 'middle', whiteSpace: 'nowrap' },
//   noDataTd: { padding: '40px 14px', textAlign: 'center', color: '#94a3b8', fontSize: '14px', fontWeight: '500' },
//   termLabel: {
//     background: '#eff6ff',
//     border: '1px solid #bfdbfe',
//     color: '#1e40af',
//     padding: '3px 8px',
//     borderRadius: '6px',
//     fontSize: '11.5px',
//     fontWeight: '700',
//   },
//   statusPill: { padding: '4px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: '700', display: 'inline-block' },
//   statusSubmitted: { background: '#fef3c7', color: '#92400e' },
//   statusVerified: { background: '#e0e7ff', color: '#3730a3' },
//   statusApproved: { background: '#d1fae5', color: '#065f46' },
//   viewRowBtn: {
//     display: 'inline-flex',
//     alignItems: 'center',
//     background: '#eff6ff',
//     border: '1px solid #bfdbfe',
//     color: '#1d4ed8',
//     padding: '5px 10px',
//     borderRadius: '6px',
//     fontSize: '12px',
//     fontWeight: '700',
//     cursor: 'pointer',
//   },
//   paginationDock: {
//     display: 'flex',
//     justifyContent: 'flex-end',
//     alignItems: 'center',
//     gap: '12px',
//     marginTop: '16px',
//     paddingTop: '12px',
//     borderTop: '1px solid #edf2f7',
//   },
//   pageIndicator: { fontSize: '13px', color: '#475569' },
//   pageBtn: {
//     background: '#ffffff',
//     border: '1px solid #e2e8f0',
//     borderRadius: '6px',
//     padding: '6px 14px',
//     color: '#334155',
//     fontSize: '12.5px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.2s',
//   },
//   pageBtnDisabled: { background: '#f8fafc', color: '#94a3b8', cursor: 'not-allowed', borderColor: '#e2e8f0' },
//   modalBackdrop: {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'rgba(15, 23, 42, 0.4)',
//     backdropFilter: 'blur(6px)',
//     zIndex: 2000,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     padding: '20px',
//   },
//   modalWrapperCard: {
//     background: '#ffffff',
//     borderRadius: '20px',
//     width: '100%',
//     maxWidth: '650px',
//     maxHeight: '90vh',
//     padding: '24px',
//     display: 'flex',
//     flexDirection: 'column',
//     boxSizing: 'border-box',
//     boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
//   },
//   modalHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'flex-start',
//     paddingBottom: '14px',
//     borderBottom: '1px solid #e2e8f0',
//   },
//   modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
//   modalBodyScroll: { overflowY: 'auto', marginTop: '14px', paddingRight: '4px' },
//   applicantInfoBanner: {
//     display: 'grid',
//     gridTemplateColumns: '1fr 1fr',
//     gap: '12px',
//     background: '#f8fafc',
//     borderRadius: '12px',
//     padding: '14px',
//     border: '1px solid #e2e8f0',
//   },
//   infoCol: { display: 'flex', flexDirection: 'column' },
//   infoLabel: { fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase' },
//   infoValue: { fontSize: '13px', fontWeight: '700', color: '#0f172a', marginTop: '2px' },
//   courseMetaBar: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     background: '#eff6ff',
//     border: '1px solid #bfdbfe',
//     borderRadius: '12px',
//     padding: '12px 14px',
//     marginTop: '12px',
//   },
//   remarksBox: {
//     background: '#ffffff',
//     borderRadius: '10px',
//     padding: '12px',
//     border: '1px solid #e2e8f0',
//     marginTop: '12px',
//   },
//   exportExcelBtn: {
//   background: '#0f172a',
//   color: '#ffffff',
//   border: 'none',
//   padding: '8px 16px',
//   borderRadius: '8px',
//   fontSize: '12.5px',
//   fontWeight: '700',
//   cursor: 'pointer',
//   display: 'inline-flex',
//   alignItems: 'center',
//   gap: '6px',
//   boxShadow: '0 2px 4px rgba(15, 23, 42, 0.1)',
//   transition: 'all 0.2s ease',
// },
//   subjectsTableWrapper: {
//     border: '1px solid #e2e8f0',
//     borderRadius: '8px',
//     overflow: 'hidden',
//     marginTop: '8px',
//   },
//   subTh: { padding: '8px 12px', textAlign: 'left', fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase' },
//   modalActionDock: {
//     display: 'flex',
//     justifyContent: 'flex-end',
//     marginTop: '20px',
//     paddingTop: '14px',
//     borderTop: '1px solid #e2e8f0',
//   },
//   modalCloseBtn: {
//     background: '#2563eb',
//     border: 'none',
//     color: '#ffffff',
//     padding: '8px 18px',
//     borderRadius: '8px',
//     fontSize: '13px',
//     fontWeight: '700',
//     cursor: 'pointer',
//   },
// };

import React, { useState, useEffect } from 'react';
import { 
  Search, 
  Loader2, 
  Eye, 
  X, 
  Download, 
  Plus, 
  Edit3, 
  Trash2, 
  CheckSquare, 
  Square,
  Building2,
  Calendar,
  Printer
} from 'lucide-react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';

export default function CiaAcknowledgementsList() {
  const [dataList, setDataList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [tableLoading, setTableLoading] = useState(false);
  const [selectedAck, setSelectedAck] = useState(null); // Detail View Modal

  // Create / Edit Modal States
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  // Master Reference Data
  const [studentsList, setStudentsList] = useState([]);
  const [masterCoursesData, setMasterCoursesData] = useState([]);
  const [availableSemesters, setAvailableSemesters] = useState([]);
  const [allAvailablePapers, setAllAvailablePapers] = useState([]);

  // Candidate Live Picker States
  const [studentPickerSearch, setStudentPickerSearch] = useState('');
  const [isPickerDropdownOpen, setIsPickerDropdownOpen] = useState(false);
  const [studentEnrolledCourses, setStudentEnrolledCourses] = useState([]);

  // Form Fields State
  const [formSubmissionDate, setFormSubmissionDate] = useState(new Date().toISOString().split('T')[0]);
  const [formStudentId, setFormStudentId] = useState('');
  const [formCandidateName, setFormCandidateName] = useState('');
  const [formCourseName, setFormCourseName] = useState('');
  const [formCourseId, setFormCourseId] = useState(0);
  const [formCourseCode, setFormCourseCode] = useState('');
  const [formEnrolmentNo, setFormEnrolmentNo] = useState('');
  const [formUniversityAdmNo, setFormUniversityAdmNo] = useState('');
  const [formYearOfAdmission, setFormYearOfAdmission] = useState('2026-2027');
  const [formRemarks, setFormRemarks] = useState('');
  const [formStatus, setFormStatus] = useState('Submitted');
  const [selectedSemesters, setSelectedSemesters] = useState(['Semester 1']);
  const [selectedPaperCodes, setSelectedPaperCodes] = useState([]);

  // Pagination Controls
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  useEffect(() => {
    fetchAcknowledgements();
  }, [searchTerm]);

  useEffect(() => {
    fetchMasterData();
  }, []);

  const fetchAcknowledgements = async () => {
    setTableLoading(true);
    try {
      const res = await fetch(
        `https://metapi.emedhatechnologies.com/api/exams/cia-acknowledgements?search=${encodeURIComponent(searchTerm)}`
      );
      const result = await res.json();
      if (result.success) setDataList(result.data || []);
      else setDataList([]);
    } catch (err) {
      console.error('Failed to load CIA acknowledgements:', err);
      setDataList([]);
    } finally {
      setTableLoading(false);
    }
  };

  const fetchMasterData = async () => {
    try {
      const [stdRes, crsRes] = await Promise.all([
        fetch('https://metapi.emedhatechnologies.com/api/students?tabStatus=all&search='),
        fetch('https://metapi.emedhatechnologies.com/api/courses/browse-courses')
      ]);

      const [stdData, crsData] = await Promise.all([stdRes.json(), crsRes.json()]);

      if (stdData.success) setStudentsList(stdData.data || []);
      if (crsData.success) setMasterCoursesData(crsData.data || []);
    } catch (err) {
      console.error('Failed to load master lookup data:', err);
    }
  };

  const extractTermNumber = (termStr) => {
    if (!termStr) return '1';
    const match = termStr.match(/\d+/);
    return match ? match[0] : '1';
  };

  // Syllabus and Papers Extraction Engine
  const setupSemestersAndPapers = (targetCourseName, targetSems = ['Semester 1'], masterList = masterCoursesData) => {
    if (!targetCourseName) return [];

    const matchedMaster = masterList.find((c) => {
      const dbName = (c.course_name || '').trim().toLowerCase();
      const searchName = targetCourseName.trim().toLowerCase();
      return dbName === searchName || dbName.includes(searchName) || searchName.includes(dbName);
    });

    const activeCourseCode = matchedMaster?.course_code || '101';
    setFormCourseCode(activeCourseCode);
    setFormCourseId(matchedMaster?.id || 0);

    let parsedSyllabus = [];
    if (matchedMaster && matchedMaster.syllabus_structure) {
      parsedSyllabus = matchedMaster.syllabus_structure;
      if (typeof parsedSyllabus === 'string') {
        try {
          parsedSyllabus = JSON.parse(parsedSyllabus);
          if (typeof parsedSyllabus === 'string') parsedSyllabus = JSON.parse(parsedSyllabus);
        } catch (e) {
          parsedSyllabus = [];
        }
      }
    }

    let sems = [];
    if (Array.isArray(parsedSyllabus) && parsedSyllabus.length > 0) {
      sems = parsedSyllabus.map((s) => s.term).filter((t) => t && t.trim() !== '');
    }
    if (sems.length === 0) {
      const durationYears = parseInt(matchedMaster?.minimum_duration) || 3;
      const isNonSemester = matchedMaster?.structure_type?.toLowerCase().includes('non');
      if (isNonSemester) {
        for (let i = 1; i <= durationYears; i++) sems.push(`Year ${i}`);
      } else {
        for (let i = 1; i <= durationYears * 2; i++) sems.push(`Semester ${i}`);
      }
    }
    setAvailableSemesters(sems);

    const activeSems = targetSems.length > 0 ? targetSems : [sems[0] || 'Semester 1'];
    setSelectedSemesters(activeSems);

    let aggregatedPapers = [];
    activeSems.forEach((semName) => {
      const semNum = extractTermNumber(semName);
      const matchedSemObj = parsedSyllabus.find(
        (s) => (s.term || '').trim().toLowerCase() === semName.trim().toLowerCase()
      );

      if (matchedSemObj && Array.isArray(matchedSemObj.papers)) {
        const papers = matchedSemObj.papers
          .filter((p) => p && p.trim() !== '')
          .map((p, idx) => ({
            code: `${activeCourseCode}${semNum}${idx + 1}`,
            title: p.trim(),
            semester: semName,
          }));
        aggregatedPapers = [...aggregatedPapers, ...papers];
      }
    });

    setAllAvailablePapers(aggregatedPapers);
    return aggregatedPapers;
  };

  // Filter candidate search results in Add Modal
  const filteredCandidateList = studentsList.filter((s) => {
    const term = studentPickerSearch.toLowerCase();
    const name = (s.name || '').toLowerCase();
    const mobile = (s.mobile || '').toLowerCase();
    const email = (s.email || '').toLowerCase();
    const adm = (s.adm_number || s.roll_number || '').toLowerCase();
    const course = (s.target_course || '').toLowerCase();

    return name.includes(term) || mobile.includes(term) || email.includes(term) || adm.includes(term) || course.includes(term);
  });

  // Candidate Selection Handler
  const handleSelectCandidate = (candidate) => {
    setFormStudentId(candidate.id);
    setFormCandidateName(candidate.name || '');
    setFormEnrolmentNo(candidate.roll_number || candidate.adm_number || `MET-ADM-${candidate.id}`);
    setFormUniversityAdmNo(candidate.university_adm_number || '');
    setFormYearOfAdmission(candidate.academic_year || '2026-2027');

    const rawCourses = candidate.target_course || '';
    const parsedCourses = rawCourses
      .split(',')
      .map(c => c.trim())
      .filter(Boolean);

    setStudentEnrolledCourses(parsedCourses);

    const primaryCourse = parsedCourses.length > 0 ? parsedCourses[0] : rawCourses;
    setFormCourseName(primaryCourse);

    const papers = setupSemestersAndPapers(primaryCourse, ['Semester 1']);
    if (papers && papers.length > 0) {
      setSelectedPaperCodes(papers.map(p => p.code));
    }

    setStudentPickerSearch(`${candidate.name} (${candidate.adm_number || candidate.roll_number || `MET-ADM-${candidate.id}`})`);
    setIsPickerDropdownOpen(false);
  };

  const handleSwitchCourse = (courseName) => {
    setFormCourseName(courseName);
    const papers = setupSemestersAndPapers(courseName, ['Semester 1']);
    if (papers && papers.length > 0) {
      setSelectedPaperCodes(papers.map(p => p.code));
    }
  };

  const toggleSemester = (sem) => {
    let updated;
    if (selectedSemesters.includes(sem)) {
      if (selectedSemesters.length === 1) return;
      updated = selectedSemesters.filter((s) => s !== sem);
    } else {
      updated = [...selectedSemesters, sem];
    }
    const papers = setupSemestersAndPapers(formCourseName, updated);
    if (papers) {
      setSelectedPaperCodes(papers.map((p) => p.code));
    }
  };

  const togglePaper = (code) => {
    if (selectedPaperCodes.includes(code)) {
      setSelectedPaperCodes(selectedPaperCodes.filter((c) => c !== code));
    } else {
      setSelectedPaperCodes([...selectedPaperCodes, code]);
    }
  };

  // Open "Add Acknowledgement" Modal
  const handleOpenAddModal = () => {
    setEditingId(null);
    setStudentPickerSearch('');
    setIsPickerDropdownOpen(false);
    setStudentEnrolledCourses([]);
    setFormSubmissionDate(new Date().toISOString().split('T')[0]);
    setFormStudentId('');
    setFormCandidateName('');
    setFormCourseName('');
    setFormCourseId(0);
    setFormCourseCode('');
    setFormEnrolmentNo('');
    setFormUniversityAdmNo('');
    setFormYearOfAdmission('2026-2027');
    setFormRemarks('');
    setFormStatus('Submitted');
    setSelectedSemesters(['Semester 1']);
    setAllAvailablePapers([]);
    setSelectedPaperCodes([]);
    setIsFormModalOpen(true);
  };

  // Open "Edit Acknowledgement" Modal
  const handleOpenEditModal = (ack) => {
    setEditingId(ack.id);
    setFormSubmissionDate(ack.submission_date ? ack.submission_date.split('T')[0] : new Date().toISOString().split('T')[0]);
    setFormStudentId(ack.student_id || '');
    setFormCandidateName(ack.candidate_name || '');
    setFormCourseName(ack.course_name || '');
    setFormCourseId(ack.course_id || 0);
    setFormCourseCode(ack.course_code || '');
    setFormEnrolmentNo(ack.enrolment_number || '');
    setFormUniversityAdmNo(ack.enrolment_number || '');
    setFormYearOfAdmission(ack.year_of_admission || '2026-2027');
    setFormRemarks(ack.remarks || '');
    setFormStatus(ack.status || 'Submitted');

    const sems = ack.semester 
      ? ack.semester.split(',').map((s) => s.trim()).filter(Boolean)
      : ['Semester 1'];

    setupSemestersAndPapers(ack.course_name, sems);

    let parsedPapers = [];
    if (ack.papers_json) {
      try {
        parsedPapers = typeof ack.papers_json === 'string' ? JSON.parse(ack.papers_json) : ack.papers_json;
      } catch (e) {
        parsedPapers = [];
      }
    }
    setSelectedPaperCodes(parsedPapers.map((p) => p.code));
    setIsFormModalOpen(true);
  };

  // Submit Handler for Add / Edit
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!formCandidateName || !formCourseName) {
      alert('Please select or specify candidate name and enrolled course stream.');
      return;
    }

    const finalPapers = allAvailablePapers.filter((p) => selectedPaperCodes.includes(p.code));
    if (finalPapers.length === 0) {
      alert('Please check at least one subject paper.');
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        submissionDate: formSubmissionDate,
        studentId: formStudentId || 0,
        candidateName: formCandidateName,
        courseId: formCourseId || 0,
        courseName: formCourseName,
        courseCode: formCourseCode,
        enrolmentNumber: formEnrolmentNo,
        universityAdmNumber: formUniversityAdmNo,
        semester: selectedSemesters.join(', '),
        yearOfAdmission: formYearOfAdmission,
        noOfPapersSubmitted: finalPapers.length,
        papers: finalPapers,
        remarks: formRemarks,
        status: formStatus
      };

      const url = editingId
        ? `https://metapi.emedhatechnologies.com/api/courses/cia-ack/update/${editingId}`
        : `https://metapi.emedhatechnologies.com/api/courses/cia-ack/submit`;

      const method = editingId ? 'PUT' : 'POST';

      const res = await fetch(url, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await res.json();

      if (result.success) {
        setIsFormModalOpen(false);
        fetchAcknowledgements();
        alert(editingId ? 'Acknowledgement updated successfully!' : 'Acknowledgement logged successfully!');
      } else {
        alert(result.message || 'Operation failed.');
      }
    } catch (err) {
      console.error('Error saving CIA acknowledgement:', err);
      alert('Network error while saving acknowledgement.');
    } finally {
      setSubmitting(false);
    }
  };

  // Delete Handler
  const handleDeleteAck = async (id) => {
    if (!window.confirm(`Are you sure you want to delete CIA Acknowledgement record #${id}?`)) return;

    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/courses/cia-ack/delete/${id}`, {
        method: 'DELETE'
      });
      const result = await res.json();
      if (result.success) {
        fetchAcknowledgements();
      } else {
        alert(result.message || 'Failed to delete record.');
      }
    } catch (err) {
      console.error('Delete error:', err);
      alert('Network error deleting record.');
    }
  };

  const handleExportToExcel = () => {
    if (dataList.length === 0) {
      alert("No CIA acknowledgement records available to export.");
      return;
    }

    const exportData = dataList.map((item, index) => ({
      "S.No": index + 1,
      "Record ID": `#${item.id}`,
      "Enrolment Number": item.enrolment_number || 'N/A',
      "Candidate Name": item.candidate_name || 'N/A',
      "Course Stream": item.course_name || 'N/A',
      "Course Code": item.course_code || 'N/A',
      "Term / Semester": item.semester || 'Semester 1',
      "Admission Year": item.year_of_admission || 'N/A',
      "No of Papers Submitted": item.no_of_papers_submitted || (item.papers_list ? item.papers_list.length : 0),
      "Submission Date": item.submission_date || (item.created_at ? new Date(item.created_at).toLocaleDateString('en-IN') : 'N/A'),
      "Status": item.status || 'Submitted',
      "Remarks": item.remarks || 'N/A'
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "CIA_Acknowledgements");

    const fileName = `CIA_Acknowledgements_Report_${new Date().toISOString().substring(0, 10)}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };


  // 1. 📄 Export Individual CIA Acknowledgement Receipt as PDF
const handleDownloadSingleAckPDF = (ack) => {
  if (!ack) return;
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });

  // Top Banner
  doc.setFillColor(15, 23, 42); // Dark Slate #0f172a
  doc.rect(0, 0, doc.internal.pageSize.width, 60, 'F');

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.setTextColor(255, 255, 255);
  doc.text("CONTINUOUS INTERNAL ASSESSMENT (CIA) ACKNOWLEDGEMENT", 40, 28);

  doc.setFontSize(9.5);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(148, 163, 184);
  doc.text("Directorate of Distance and Online Education • Assignment Submission Wing", 40, 46);

  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(56, 189, 248);
  doc.text(`Ack ID: #${ack.id}`, doc.internal.pageSize.width - 40, 36, { align: 'right' });

  // Candidate Details Table
  autoTable(doc, {
    startY: 75,
    theme: 'plain',
    body: [
      ['Candidate Name:', (ack.candidate_name || 'N/A').toUpperCase(), 'Enrolment / Reg No:', ack.enrolment_number || 'N/A'],
      ['Course Stream:', `${ack.course_name || 'N/A'} (${ack.course_code || 'N/A'})`, 'Appearing Term / Sem:', ack.semester || 'Semester 1'],
      ['Admission Year:', ack.year_of_admission || '2026-2027', 'Submission Date:', ack.submission_date || (ack.created_at ? new Date(ack.created_at).toLocaleDateString('en-IN') : 'N/A')],
      ['Status:', ack.status || 'Submitted', 'Papers Submitted:', `${ack.no_of_papers_submitted || 0} Papers`],
      ['Remarks:', { content: ack.remarks || 'None', colSpan: 3 }]
    ],
    styles: { fontSize: 8.5, textColor: [51, 65, 85], cellPadding: 3.5 },
    columnStyles: {
      0: { fontStyle: 'bold', cellWidth: 105 },
      2: { fontStyle: 'bold', cellWidth: 105 }
    }
  });

  // Parse Submitted Papers List
  let papers = [];
  if (ack.papers_json) {
    try {
      papers = typeof ack.papers_json === 'string' ? JSON.parse(ack.papers_json) : ack.papers_json;
    } catch (e) {
      papers = [];
    }
  }

  const paperRows = papers.map((paper, idx) => [
    String(idx + 1).padStart(2, '0'),
    paper.code || 'N/A',
    paper.title || 'N/A',
    paper.semester || ack.semester || 'Active Term'
  ]);

  // Papers Table
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 12,
    theme: 'grid',
    head: [['#', 'Subject Code', 'Title of the Assignment / Paper', 'Term']],
    body: paperRows.length > 0 ? paperRows : [['-', '-', 'No specific papers list recorded', '-']],
    headStyles: { fillColor: [28, 110, 201], textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 8.5 },
    bodyStyles: { fontSize: 8.5, textColor: [51, 65, 85] },
    alternateRowStyles: { fillColor: [248, 250, 252] },
    columnStyles: {
      0: { halign: 'center', cellWidth: 28 },
      1: { fontStyle: 'bold', textColor: [37, 99, 235], cellWidth: 80 },
      3: { cellWidth: 90 }
    }
  });

  // Footer Signatures
  const finalY = doc.lastAutoTable.finalY + 45;
  if (finalY < doc.internal.pageSize.height - 40) {
    doc.setFontSize(8.5);
    doc.setTextColor(100, 116, 139);
    doc.text("Candidate Signature", 50, finalY);
    doc.text("Learning Centre Authorized Seal & Signature", doc.internal.pageSize.width - 50, finalY, { align: 'right' });
    doc.setDrawColor(203, 213, 225);
    doc.line(50, finalY - 12, 160, finalY - 12);
    doc.line(doc.internal.pageSize.width - 220, finalY - 12, doc.internal.pageSize.width - 50, finalY - 12);
  }

  doc.save(`CIA_Ack_${ack.enrolment_number || ack.id}_${(ack.candidate_name || 'Candidate').replace(/\s+/g, '_')}.pdf`);
};

// 2. 📊 Export Filtered CIA Acknowledgements Table to PDF
const handleExportAllToPDF = () => {
  if (dataList.length === 0) {
    alert("No CIA acknowledgement records available to export.");
    return;
  }

  const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });

  // Banner
  doc.setFillColor(15, 23, 42);
  doc.rect(0, 0, doc.internal.pageSize.width, 55, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(15);
  doc.setTextColor(255, 255, 255);
  doc.text("CIA SUBMISSION ACKNOWLEDGEMENTS MASTER REPORT", 40, 28);

  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(148, 163, 184);
  doc.text(`Total Records: ${dataList.length} | Generated on: ${new Date().toLocaleDateString('en-IN')}`, 40, 44);

  const tableColumns = [
    { header: '#', dataKey: 'index' },
    { header: 'Enrolment No', dataKey: 'enrolment_number' },
    { header: 'Candidate Name', dataKey: 'candidate_name' },
    { header: 'Course Stream', dataKey: 'course_name' },
    { header: 'Code', dataKey: 'course_code' },
    { header: 'Term / Sem', dataKey: 'semester' },
    { header: 'Admission Year', dataKey: 'year_of_admission' },
    { header: 'Papers', dataKey: 'papers' },
    { header: 'Submission Date', dataKey: 'submission_date' },
    { header: 'Status', dataKey: 'status' }
  ];

  const tableRows = dataList.map((item, i) => ({
    index: String(i + 1).padStart(2, '0'),
    enrolment_number: item.enrolment_number || 'N/A',
    candidate_name: (item.candidate_name || 'N/A').toUpperCase(),
    course_name: item.course_name || 'N/A',
    course_code: item.course_code || 'N/A',
    semester: item.semester || 'Semester 1',
    year_of_admission: item.year_of_admission || '2026-2027',
    papers: `${item.no_of_papers_submitted || 0} Papers`,
    submission_date: item.submission_date || formatDate(item.created_at),
    status: item.status || 'Submitted'
  }));

  autoTable(doc, {
    startY: 68,
    columns: tableColumns,
    body: tableRows,
    theme: 'grid',
    headStyles: { fillColor: [28, 110, 201], textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 8.5 },
    bodyStyles: { fontSize: 8, textColor: [51, 65, 85] },
    alternateRowStyles: { fillColor: [248, 250, 252] },
    columnStyles: {
      index: { halign: 'center', cellWidth: 26 },
      enrolment_number: { fontStyle: 'bold', textColor: [30, 64, 175] }
    },
    margin: { left: 40, right: 40, bottom: 40 }
  });

  doc.save(`CIA_Acknowledgements_Report_${new Date().toISOString().substring(0, 10)}.pdf`);
};

// 3. 🖨️ Direct Print Engine with Clean Document Layout
const handleDirectPrintAck = (ack) => {
  if (!ack) return;

  let parsedPapers = [];
  if (ack.papers_json) {
    try {
      parsedPapers = typeof ack.papers_json === 'string' ? JSON.parse(ack.papers_json) : ack.papers_json;
    } catch (e) {
      parsedPapers = [];
    }
  }

  const printWindow = window.open('', '_blank', 'width=900,height=700');
  if (!printWindow) {
    alert("Please allow popups to open the print window.");
    return;
  }

  const printHTML = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>CIA Acknowledgement - ${ack.enrolment_number || ack.candidate_name}</title>
        <style>
          @page { size: A4 portrait; margin: 15mm; }
          * { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif; color: #0f172a; margin: 0; padding: 10px; font-size: 13px; line-height: 1.4; }
          
          /* Header */
          .header-banner { border-bottom: 2px solid #1e40af; padding-bottom: 14px; margin-bottom: 16px; display: flex; justify-content: space-between; align-items: flex-start; }
          .inst-title { font-size: 17px; font-weight: 800; color: #1e40af; text-transform: uppercase; margin: 0 0 4px 0; }
          .inst-sub { font-size: 12px; color: #475569; font-weight: 600; margin: 0; }
          .doc-badge { background: #eff6ff; border: 1px solid #bfdbfe; color: #1e40af; font-weight: 800; font-size: 11px; padding: 4px 10px; border-radius: 4px; text-transform: uppercase; }
          
          /* Metadata Matrix */
          .section-title { font-size: 11px; font-weight: 800; color: #475569; text-transform: uppercase; letter-spacing: 0.5px; margin: 14px 0 6px 0; }
          .info-table { width: 100%; border-collapse: collapse; margin-bottom: 14px; border: 1px solid #e2e8f0; }
          .info-table td { padding: 7px 10px; font-size: 12.5px; border: 1px solid #e2e8f0; }
          .info-table td.label { font-weight: 700; color: #475569; background: #f8fafc; width: 22%; }
          .info-table td.val { font-weight: 600; color: #0f172a; width: 28%; }
          
          /* Papers Table */
          .papers-table { width: 100%; border-collapse: collapse; margin-top: 6px; }
          .papers-table th { background: #f1f5f9; color: #334155; font-size: 11px; font-weight: 700; text-transform: uppercase; padding: 8px 10px; border: 1px solid #cbd5e1; text-align: left; }
          .papers-table td { padding: 8px 10px; border: 1px solid #e2e8f0; font-size: 12px; }
          .sub-code { font-weight: 800; color: #2563eb; }

          /* Declaration & Signatures */
          .declaration-box { margin-top: 20px; font-size: 11px; color: #64748b; text-align: justify; line-height: 1.5; border-top: 1px dashed #cbd5e1; padding-top: 10px; }
          .signatures-dock { display: flex; justify-content: space-between; margin-top: 50px; padding: 0 15px; }
          .sig-line-box { width: 200px; text-align: center; font-size: 11.5px; font-weight: 700; color: #334155; }
          .sig-line { border-top: 1px solid #94a3b8; margin-bottom: 6px; }
        </style>
      </head>
      <body>
        <div class="header-banner">
          <div>
            <h1 class="inst-title">ALAGAPPA UNIVERSITY</h1>
            <p class="inst-sub">Centre for Distance and Online Education • Continuous Internal Assessment (CIA)</p>
          </div>
          <div style="text-align: right;">
            <div class="doc-badge">Submission Receipt</div>
            <div style="font-size: 11px; color: #64748b; margin-top: 4px;">Record ID: #${ack.id}</div>
          </div>
        </div>

        <div class="section-title">Candidate & Submission Particulars</div>
        <table class="info-table">
          <tr>
            <td class="label">Candidate Name</td>
            <td class="val"><strong>${(ack.candidate_name || '').toUpperCase()}</strong></td>
            <td class="label">Enrolment / Reg No</td>
            <td class="val" style="color: #1e40af; font-weight: 800;">${ack.enrolment_number || 'N/A'}</td>
          </tr>
          <tr>
            <td class="label">Course Stream</td>
            <td class="val"><strong>${ack.course_name || '-'}</strong></td>
            <td class="label">Course Code</td>
            <td class="val">${ack.course_code || '-'}</td>
          </tr>
          <tr>
            <td class="label">Term / Semester</td>
            <td class="val">${ack.semester || 'Semester 1'}</td>
            <td class="label">Admission Year</td>
            <td class="val">${ack.year_of_admission || '2026-2027'}</td>
          </tr>
          <tr>
            <td class="label">Submission Date</td>
            <td class="val">${ack.submission_date || (ack.created_at ? new Date(ack.created_at).toLocaleDateString('en-IN') : '-')}</td>
            <td class="label">Status</td>
            <td class="val" style="color: #059669; font-weight: 800;">${ack.status || 'Submitted'}</td>
          </tr>
          ${ack.remarks ? `
          <tr>
            <td class="label">Remarks</td>
            <td class="val" colspan="3">${ack.remarks}</td>
          </tr>` : ''}
        </table>

        <div class="section-title">Submitted Assignment Papers (${parsedPapers.length} Papers)</div>
        <table class="papers-table">
          <thead>
            <tr>
              <th style="width: 35px; text-align: center;">#</th>
              <th style="width: 100px;">Subject Code</th>
              <th>Title of the Course Paper</th>
              <th style="width: 110px;">Term / Sem</th>
            </tr>
          </thead>
          <tbody>
            ${parsedPapers.length === 0 ? `
              <tr><td colspan="4" style="text-align: center; color: #94a3b8; padding: 12px;">No specific papers attached.</td></tr>
            ` : parsedPapers.map((paper, idx) => `
              <tr>
                <td style="text-align: center; color: #64748b;">${idx + 1}</td>
                <td class="sub-code">${paper.code || '-'}</td>
                <td><strong>${paper.title || '-'}</strong></td>
                <td>${paper.semester || ack.semester || '-'}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>

        <div class="declaration-box">
          <strong>Acknowledgement Note:</strong> The above mentioned assignment response sheets have been officially received and recorded for Continuous Internal Assessment evaluation.
        </div>

        <div class="signatures-dock">
          <div class="sig-line-box">
            <div class="sig-line"></div>
            Candidate Signature
          </div>
          <div class="sig-line-box">
            <div class="sig-line"></div>
            Study Centre Seal &amp; Authority
          </div>
        </div>
      </body>
    </html>
  `;

  printWindow.document.open();
  printWindow.document.write(printHTML);
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
};

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? dateStr : d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = dataList.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(dataList.length / itemsPerPage);

  return (
    <div style={styles.container}>
      
      {/* ⚡ STEP 1: TOP HEADER & SEARCH FILTER BAR */}
  {/* ⚡ STEP 1: TOP HEADER & SEARCH FILTER BAR */}
<div style={styles.filterControlPanel}>
  <div style={styles.searchWrapper}>
    <Search size={16} style={styles.searchIcon} />
    <input
      type="text"
      placeholder="Search by candidate, enrollment no, course, semester..."
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={styles.tableSearchInput}
    />
  </div>

  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
    {/* Add Acknowledgement CTA */}
    <button onClick={handleOpenAddModal} style={styles.addAppBtn}>
      <Plus size={15} /> Add Acknowledgement
    </button>

    {/* Export to Excel Button */}
    <button
      type="button"
      onClick={handleExportToExcel}
      style={styles.exportExcelBtn}
      title="Export all filtered CIA acknowledgements to Excel"
    >
      <Download size={14} /> Download Excel
    </button>

    {/* ➕ Top-Level Export to PDF Button */}
    <button
      type="button"
      onClick={handleExportAllToPDF}
      style={styles.pdfExportBtn}
      title="Download Table PDF Statement"
    >
      <Download size={14} /> Download PDF
    </button>

    <div style={styles.totalIndicator}>
      Total: <strong style={{ color: '#1c6ec9' }}>{dataList.length}</strong>
    </div>
  </div>
</div>

      {/* ⚡ STEP 2: DATA TABLE */}
      {tableLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '60px' }}>
          <Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#1c6ec9" />
        </div>
      ) : (
        <div style={{ overflowX: 'auto', width: '100%', borderRadius: '14px', border: '1px solid #e2e8f0', background: '#fff' }}>
          <table style={styles.dataTable}>
            <thead>
              <tr>
                <th style={styles.tableTh}>Enrolment No</th>
                <th style={styles.tableTh}>Candidate Name</th>
                <th style={styles.tableTh}>Course Stream</th>
                <th style={styles.tableTh}>Course Code</th>
                <th style={styles.tableTh}>Term / Semester</th>
                <th style={styles.tableTh}>Admission Year</th>
                <th style={styles.tableTh}>Papers Submitted</th>
                <th style={styles.tableTh}>Submission Date</th>
                <th style={styles.tableTh}>Status</th>
                <th style={{ ...styles.tableTh, textAlign: 'center' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {dataList.length === 0 ? (
                <tr>
                  <td colSpan="10" style={styles.noDataTd}>
                    No CIA submission acknowledgements found matching your search.
                  </td>
                </tr>
              ) : (
                currentItems.map((item) => (
                  <tr key={item.id} style={styles.tableTr}>
                    <td style={{ ...styles.tableTd, fontWeight: '700', color: '#1e40af' }}>
                      {item.enrolment_number}
                    </td>
                    <td style={{ ...styles.tableTd, fontWeight: '700', color: '#0f172a' }}>
                      {item.candidate_name}
                    </td>
                    <td style={{ ...styles.tableTd, color: '#334155', fontWeight: '600' }}>
                      {item.course_name}
                    </td>
                    <td style={{ ...styles.tableTd, color: '#64748b', fontWeight: '600' }}>
                      {item.course_code}
                    </td>
                    <td style={styles.tableTd}>
                      <span style={styles.termLabel}>{item.semester || 'Semester 1'}</span>
                    </td>
                    <td style={{ ...styles.tableTd, color: '#475569', fontSize: '13px' }}>
                      {item.year_of_admission}
                    </td>
                    <td style={{ ...styles.tableTd, textAlign: 'center', fontWeight: '700', color: '#2563eb' }}>
                      {item.no_of_papers_submitted || (item.papers_list ? item.papers_list.length : 0)} Papers
                    </td>
                    <td style={{ ...styles.tableTd, fontSize: '12.5px', color: '#475569' }}>
                      {item.submission_date || formatDate(item.created_at)}
                    </td>
                    <td style={styles.tableTd}>
                      <span
                        style={{
                          ...styles.statusPill,
                          ...(item.status === 'Approved'
                            ? styles.statusApproved
                            : item.status === 'Verified'
                            ? styles.statusVerified
                            : styles.statusSubmitted),
                        }}
                      >
                        {item.status || 'Submitted'}
                      </span>
                    </td>
                    <td style={styles.tableTd}>
                      <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                      <button
      onClick={() => handleDownloadSingleAckPDF(item)}
      style={styles.actionIconButton}
      title="Download Individual CIA Acknowledgement (PDF)"
    >
      <Download size={13} color="#047857" />
    </button>
                        <button
                          onClick={() => setSelectedAck(item)}
                          style={styles.actionIconButton}
                          title="View Full Acknowledgement"
                        >
                          <Eye size={13} color="#2563eb" />
                        </button>
                        <button
                          onClick={() => handleOpenEditModal(item)}
                          style={styles.actionIconButton}
                          title="Edit Acknowledgement"
                        >
                          <Edit3 size={13} color="#059669" />
                        </button>
                        <button
                          onClick={() => handleDeleteAck(item.id)}
                          style={styles.actionIconButton}
                          title="Delete Record"
                        >
                          <Trash2 size={13} color="#dc2626" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* ⚡ STEP 3: PAGINATION */}
      {dataList.length > 0 && (
        <div style={styles.paginationDock}>
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            style={currentPage === 1 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
          >
            Previous
          </button>
          <span style={styles.pageIndicator}>
            Page <strong>{currentPage}</strong> of {totalPages || 1}
          </span>
          <button
            disabled={currentPage === totalPages || totalPages === 0}
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            style={currentPage === totalPages || totalPages === 0 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
          >
            Next
          </button>
        </div>
      )}

      {/* ⚡ MODAL 1: ADD / EDIT CIA ACKNOWLEDGEMENT FORM */}
      {isFormModalOpen && (
        <div style={styles.modalBackdrop}>
          <div style={{ ...styles.modalWrapperCard, maxWidth: '820px' }}>
            <div style={styles.modalHeader}>
              <div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '800', color: '#0f172a' }}>
                  {editingId ? `Edit CIA Acknowledgement #${editingId}` : 'Submit CIA Acknowledgement'}
                </h3>
                <span style={{ fontSize: '12px', color: '#64748b' }}>
                  Select enrolled candidate, configure course terms & verify submitted subject papers
                </span>
              </div>
              <button onClick={() => setIsFormModalOpen(false)} style={styles.modalCloseX}>
                <X size={18} />
              </button>
            </div>

            <form onSubmit={handleFormSubmit} style={styles.modalFormBody}>
              
              {/* Top Searchable Student Autocomplete Picker (Add Mode Only) */}
              {!editingId && (
                <div style={styles.studentSearchPickerBox}>
                  <label style={styles.fieldLabel}>Search & Select Enrolled Student *</label>
                  <div style={{ position: 'relative' }}>
                    <div style={styles.inputWithIconBox}>
                      <Search size={15} style={styles.inlineSearchIcon} />
                      <input
                        type="text"
                        placeholder="Type candidate name, mobile, admission no, or course..."
                        value={studentPickerSearch}
                        onChange={(e) => {
                          setStudentPickerSearch(e.target.value);
                          setIsPickerDropdownOpen(true);
                        }}
                        onFocus={() => setIsPickerDropdownOpen(true)}
                        style={styles.fieldInputWithIcon}
                      />
                      {studentPickerSearch && (
                        <button 
                          type="button" 
                          onClick={() => {
                            setStudentPickerSearch('');
                            setFormStudentId('');
                            setStudentEnrolledCourses([]);
                            setFormCourseName('');
                            setIsPickerDropdownOpen(false);
                          }}
                          style={styles.pickerClearBtn}
                        >
                          ✕
                        </button>
                      )}
                    </div>

                    {/* Autocomplete Dropdown List */}
                    {isPickerDropdownOpen && (
                      <div style={styles.studentSearchResultsDropdown}>
                        {filteredCandidateList.length === 0 ? (
                          <div style={{ padding: '12px', fontSize: '12px', color: '#94a3b8', textAlign: 'center' }}>
                            No matching students found.
                          </div>
                        ) : (
                          filteredCandidateList.slice(0, 15).map((candidate) => (
                            <div
                              key={candidate.id}
                              onClick={() => handleSelectCandidate(candidate)}
                              style={styles.candidateResultItem}
                            >
                              <div>
                                <strong style={{ color: '#0f172a', fontSize: '13px' }}>{candidate.name}</strong>
                                <span style={{ color: '#64748b', fontSize: '11.5px', marginLeft: '6px' }}>
                                  ({candidate.adm_number || candidate.roll_number || `MET-ADM-${candidate.id}`})
                                </span>
                                <div style={{ fontSize: '11px', color: '#1e40af', marginTop: '2px' }}>
                                  🎓 {candidate.target_course} • 📱 {candidate.mobile}
                                </div>
                              </div>
                              {candidate.university_adm_number ? (
                                <span style={styles.univPill}>
                                  Univ: {candidate.university_adm_number}
                                </span>
                              ) : null}
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Dynamic Enrolled Course Selector (Multi vs Single) */}
              <div style={styles.fieldContainer}>
                <label style={styles.fieldLabel}>
                  Enrolled Course Track * 
                  {studentEnrolledCourses.length > 1 && (
                    <span style={{ color: '#1e40af', fontWeight: '800', marginLeft: '6px' }}>
                      ({studentEnrolledCourses.length} Courses Enrolled — Select Active)
                    </span>
                  )}
                </label>

                {studentEnrolledCourses.length > 1 ? (
                  <div style={styles.coursePillsContainer}>
                    {studentEnrolledCourses.map((cName, idx) => {
                      const isActive = formCourseName.trim().toLowerCase() === cName.trim().toLowerCase();
                      return (
                        <button
                          key={idx}
                          type="button"
                          onClick={() => handleSwitchCourse(cName)}
                          style={{
                            ...styles.courseToggleChip,
                            background: isActive ? '#1e40af' : '#f8fafc',
                            color: isActive ? '#ffffff' : '#334155',
                            borderColor: isActive ? '#1e40af' : '#cbd5e1'
                          }}
                        >
                          {isActive ? '✓ ' : ''} {cName}
                        </button>
                      );
                    })}
                  </div>
                ) : (
                  <input
                    type="text"
                    required
                    placeholder="e.g. MBA or B.Com"
                    value={formCourseName}
                    onChange={(e) => {
                      setFormCourseName(e.target.value);
                      setupSemestersAndPapers(e.target.value, selectedSemesters);
                    }}
                    style={styles.formInput}
                  />
                )}
              </div>

              {/* Row 1: Submission Date & Course Code */}
              <div style={styles.formSplitGrid}>
                <div style={styles.fieldContainer}>
                  <label style={styles.fieldLabel}>Submission Date *</label>
                  <input
                    type="date"
                    required
                    value={formSubmissionDate}
                    onChange={(e) => setFormSubmissionDate(e.target.value)}
                    style={styles.formInput}
                  />
                </div>
                <div style={styles.fieldContainer}>
                  <label style={styles.fieldLabel}>Course Code</label>
                  <input
                    type="text"
                    placeholder="e.g. 317"
                    value={formCourseCode}
                    onChange={(e) => setFormCourseCode(e.target.value)}
                    style={styles.formInput}
                  />
                </div>
              </div>

              {/* Row 2: Candidate Name & Year of Admission */}
              <div style={styles.formSplitGrid}>
                <div style={styles.fieldContainer}>
                  <label style={styles.fieldLabel}>Candidate Full Name *</label>
                  <input
                    type="text"
                    required
                    value={formCandidateName}
                    onChange={(e) => setFormCandidateName(e.target.value)}
                    style={styles.formInput}
                  />
                </div>
                <div style={styles.fieldContainer}>
                  <label style={styles.fieldLabel}>Year of Admission (AY / CY) *</label>
                  <input
                    type="text"
                    required
                    placeholder="e.g. 2026-2027"
                    value={formYearOfAdmission}
                    onChange={(e) => setFormYearOfAdmission(e.target.value)}
                    style={styles.formInput}
                  />
                </div>
              </div>

              {/* Row 3: Enrolment No & University Admission No */}
              <div style={styles.formSplitGrid}>
                <div style={styles.fieldContainer}>
                  <label style={styles.fieldLabel}>Institute Enrolment / Reg No. *</label>
                  <input
                    type="text"
                    required
                    placeholder="e.g. MET-ADM-10"
                    value={formEnrolmentNo}
                    onChange={(e) => setFormEnrolmentNo(e.target.value)}
                    style={styles.formInput}
                  />
                </div>
                <div style={styles.fieldContainer}>
                  <label style={styles.fieldLabel}>University Admission / Reg No. *</label>
                  <input
                    type="text"
                    required
                    placeholder="e.g. AU-2026-5872026"
                    value={formUniversityAdmNo}
                    onChange={(e) => setFormUniversityAdmNo(e.target.value)}
                    style={styles.formInput}
                  />
                </div>
              </div>

              {/* Row 4: Multi-Semester Selection Checkboxes */}
              <div style={styles.fieldContainer}>
                <label style={styles.fieldLabel}>Appearing Terms / Semesters for {formCourseName || 'Course'}</label>
                <div style={styles.checkboxPillsContainer}>
                  {availableSemesters.length === 0 ? (
                    <span style={{ fontSize: '12px', color: '#94a3b8', fontStyle: 'italic' }}>
                      Select a candidate/course to load available semesters.
                    </span>
                  ) : (
                    availableSemesters.map((sem, idx) => {
                      const isSelected = selectedSemesters.includes(sem);
                      return (
                        <button
                          key={idx}
                          type="button"
                          onClick={() => toggleSemester(sem)}
                          style={{
                            ...styles.semesterToggleChip,
                            background: isSelected ? '#1e40af' : '#f8fafc',
                            color: isSelected ? '#ffffff' : '#334155',
                            borderColor: isSelected ? '#1e40af' : '#cbd5e1'
                          }}
                        >
                          {isSelected ? '✓ ' : '+ '} {sem}
                        </button>
                      );
                    })
                  )}
                </div>
              </div>

              {/* Row 5: Submitted Subject Papers Checklist */}
              <div style={styles.fieldContainer}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                  <label style={styles.fieldLabel}>
                    Submitted Subject Papers ({selectedPaperCodes.length} of {allAvailablePapers.length} Selected)
                  </label>
                  {allAvailablePapers.length > 0 && (
                    <button
                      type="button"
                      onClick={() => {
                        if (selectedPaperCodes.length === allAvailablePapers.length) {
                          setSelectedPaperCodes([]);
                        } else {
                          setSelectedPaperCodes(allAvailablePapers.map((p) => p.code));
                        }
                      }}
                      style={styles.linkButton}
                    >
                      {selectedPaperCodes.length === allAvailablePapers.length ? 'Deselect All' : 'Select All Papers'}
                    </button>
                  )}
                </div>

                <div style={styles.papersCardDeck}>
                  {allAvailablePapers.length === 0 ? (
                    <div style={{ padding: '20px', textAlign: 'center', color: '#94a3b8', fontSize: '12.5px' }}>
                      Please select a course to view syllabus papers.
                    </div>
                  ) : (
                    allAvailablePapers.map((paper, idx) => {
                      const isChecked = selectedPaperCodes.includes(paper.code);
                      return (
                        <div
                          key={idx}
                          onClick={() => togglePaper(paper.code)}
                          style={{
                            ...styles.paperCheckRow,
                            background: isChecked ? '#eff6ff' : '#ffffff',
                            borderColor: isChecked ? '#bfdbfe' : '#e2e8f0'
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {isChecked ? <CheckSquare size={16} color="#2563eb" /> : <Square size={16} color="#94a3b8" />}
                            <span style={{ fontWeight: '700', color: '#1e40af', fontSize: '12.5px' }}>{paper.code}</span>
                            <span style={{ fontSize: '12.5px', color: '#334155' }}>{paper.title}</span>
                          </div>
                          <span style={styles.paperSemBadge}>{paper.semester}</span>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>

              {/* Remarks Box */}
              <div style={styles.fieldContainer}>
                <label style={styles.fieldLabel}>Remarks / Submission Notes</label>
                <input
                  type="text"
                  placeholder="e.g. All assignment booklets verified and received"
                  value={formRemarks}
                  onChange={(e) => setFormRemarks(e.target.value)}
                  style={styles.formInput}
                />
              </div>

              {/* Status Selector (If Editing) */}
              {editingId && (
                <div style={styles.fieldContainer}>
                  <label style={styles.fieldLabel}>Acknowledgement Status</label>
                  <select
                    value={formStatus}
                    onChange={(e) => setFormStatus(e.target.value)}
                    style={styles.formSelect}
                  >
                    <option value="Submitted">Submitted</option>
                    <option value="Verified">Verified</option>
                    <option value="Approved">Approved</option>
                  </select>
                </div>
              )}

              {/* Total Papers Count Highlight Card */}
              <div style={styles.papersSummaryHighlightCard}>
                <div>
                  <span style={{ fontSize: '11px', color: '#1e40af', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                    CIA Submission Scope
                  </span>
                  <div style={{ fontSize: '13px', color: '#334155', fontWeight: '600', marginTop: '2px' }}>
                    Course: <strong>{formCourseName}</strong> ({selectedSemesters.join(', ')})
                  </div>
                </div>
                <div style={styles.selectedCountBadgeBox}>
                  <span style={{ fontSize: '10px', color: '#64748b', textTransform: 'uppercase', fontWeight: '700' }}>Total Papers</span>
                  <strong style={{ fontSize: '18px', color: '#1e40af', fontWeight: '900' }}>
                    {selectedPaperCodes.length}
                  </strong>
                </div>
              </div>

              {/* Form Actions Footer */}
              <div style={styles.formActionDock}>
                <button type="button" onClick={() => setIsFormModalOpen(false)} style={styles.formCancelBtn}>
                  Cancel
                </button>
                <button type="submit" disabled={submitting} style={styles.formSaveBtn}>
                  {submitting ? 'Processing...' : editingId ? 'Save Changes' : `Submit Acknowledgement (${selectedPaperCodes.length} Papers)`}
                </button>
              </div>

            </form>
          </div>
        </div>
      )}

      {/* ⚡ MODAL 2: DETAILED ACKNOWLEDGEMENT VIEW MODAL */}
      {selectedAck && (
        <div style={styles.modalBackdrop}>
          <div style={styles.modalWrapperCard}>
            <div style={styles.modalHeader}>
              <div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '800', color: '#0f172a' }}>
                  CIA Submission Acknowledgement Details
                </h3>
                <span style={{ fontSize: '12px', color: '#64748b' }}>
                  Record ID: #{selectedAck.id} • Submitted: {selectedAck.submission_date || formatDate(selectedAck.created_at)}
                </span>
              </div>
              <button onClick={() => setSelectedAck(null)} style={styles.modalCloseX}>
                <X size={18} />
              </button>
            </div>

            <div style={styles.modalBodyScroll}>
              {/* Candidate Info Grid Banner */}
              <div style={styles.applicantInfoBanner}>
                <div style={styles.infoCol}>
                  <span style={styles.infoLabel}>Candidate Name</span>
                  <span style={styles.infoValue}>{selectedAck.candidate_name}</span>
                </div>
                <div style={styles.infoCol}>
                  <span style={styles.infoLabel}>Enrolment Number</span>
                  <span style={{ ...styles.infoValue, color: '#1e40af' }}>{selectedAck.enrolment_number}</span>
                </div>
                <div style={styles.infoCol}>
                  <span style={styles.infoLabel}>Admission Year</span>
                  <span style={styles.infoValue}>{selectedAck.year_of_admission}</span>
                </div>
                <div style={styles.infoCol}>
                  <span style={styles.infoLabel}>Status</span>
                  <span style={{ ...styles.infoValue, color: '#059669' }}>{selectedAck.status || 'Submitted'}</span>
                </div>
              </div>

              {/* Course Meta Banner */}
              <div style={styles.courseMetaBar}>
                <div>
                  <span style={{ fontSize: '11px', color: '#64748b', textTransform: 'uppercase', fontWeight: '700' }}>Course</span>
                  <div style={{ fontSize: '14px', fontWeight: '800', color: '#0f172a' }}>
                    {selectedAck.course_name} {selectedAck.course_code ? `(${selectedAck.course_code})` : ''}
                  </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <span style={{ fontSize: '11px', color: '#64748b', textTransform: 'uppercase', fontWeight: '700' }}>Semester</span>
                  <div style={{ fontSize: '13px', fontWeight: '700', color: '#1e40af' }}>
                    {selectedAck.semester}
                  </div>
                </div>
              </div>

              {/* Submitted Subject Papers Table */}
              <div style={{ marginTop: '16px' }}>
                <span style={{ fontSize: '12px', fontWeight: '800', color: '#0f172a', textTransform: 'uppercase' }}>
                  Submitted Papers ({selectedAck.no_of_papers_submitted || 0} Papers)
                </span>
                <div style={styles.subjectsTableWrapper}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: '#f1f5f9' }}>
                        <th style={{ ...styles.subTh, width: '90px' }}>Sub Code</th>
                        <th style={styles.subTh}>Title of the Course Paper</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        let papers = [];
                        if (selectedAck.papers_json) {
                          try {
                            papers = typeof selectedAck.papers_json === 'string'
                              ? JSON.parse(selectedAck.papers_json)
                              : selectedAck.papers_json;
                          } catch (e) {
                            papers = [];
                          }
                        }
                        if (papers.length === 0) {
                          return (
                            <tr>
                              <td colSpan="2" style={{ padding: '12px', textAlign: 'center', color: '#94a3b8', fontSize: '12px' }}>
                                No specific papers recorded.
                              </td>
                            </tr>
                          );
                        }
                        return papers.map((paper, idx) => (
                          <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                            <td style={{ padding: '8px 12px', fontWeight: '700', color: '#2563eb', fontSize: '12.5px' }}>
                              {paper.code}
                            </td>
                            <td style={{ padding: '8px 12px', color: '#334155', fontSize: '12.5px' }}>
                              {paper.title}
                            </td>
                          </tr>
                        ));
                      })()}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Remarks Box */}
              {selectedAck.remarks ? (
                <div style={styles.remarksBox}>
                  <span style={styles.infoLabel}>Remarks</span>
                  <div style={{ fontSize: '12.5px', color: '#334155', marginTop: '2px' }}>
                    {selectedAck.remarks}
                  </div>
                </div>
              ) : null}

              {/* Modal Footer Close Action */}
            {/* Modal Footer Summary & Print Actions */}
<div style={styles.modalActionDock}>
  <div style={{ display: 'flex', gap: '8px' }}>
    {/* 🖨️ Direct Print Button */}
    <button
      type="button"
      onClick={() => handleDirectPrintAck(selectedAck)}
      style={styles.modalPrintBtn}
    >
      <Printer size={14} /> Print Acknowledgement
    </button>

    <button onClick={() => setSelectedAck(null)} style={styles.modalCloseBtn}>
      Close Window
    </button>
  </div>
</div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

// ⚡ DESIGN STYLES
const styles = {
  container: { width: '100%', boxSizing: 'border-box' },
  filterControlPanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '16px',
    flexWrap: 'wrap',
  },
  searchWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    maxWidth: '380px',
    width: '100%',
  },
  searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
  tableSearchInput: {
    width: '100%',
    padding: '10px 12px 10px 38px',
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    color: '#0f172a',
    fontSize: '13px',
    outline: 'none',
  },
  addAppBtn: {
    background: 'linear-gradient(90deg, #e30504 0%, #a80302 100%)',
    border: 'none',
    borderRadius: '8px',
    color: '#fff',
    padding: '9px 16px',
    fontSize: '12.5px',
    fontWeight: '700',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    whiteSpace: 'nowrap'
  },
  pdfExportBtn: {
  background: '#0f172a',
  color: '#ffffff',
  border: 'none',
  padding: '9px 15px',
  borderRadius: '8px',
  fontSize: '12.5px',
  fontWeight: '700',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  whiteSpace: 'nowrap'
},
modalPrintBtn: {
  background: '#1e40af',
  color: '#ffffff',
  border: 'none',
  padding: '8px 16px',
  borderRadius: '8px',
  fontSize: '12.5px',
  fontWeight: '700',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  boxShadow: '0 2px 4px rgba(30, 64, 175, 0.2)',
  transition: 'all 0.15s ease'
},
  exportExcelBtn: {
    background: '#0f172a',
    color: '#ffffff',
    border: 'none',
    padding: '9px 16px',
    borderRadius: '8px',
    fontSize: '12.5px',
    fontWeight: '700',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    whiteSpace: 'nowrap'
  },
  totalIndicator: { fontSize: '13.5px', fontWeight: '600', color: '#475569' },
  dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left', background: '#ffffff' },
  tableTh: {
    padding: '12px 14px',
    borderBottom: '2px solid #e2e8f0',
    background: '#f8fafc',
    color: '#64748b',
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontWeight: '700',
    whiteSpace: 'nowrap',
  },
  tableTr: { borderBottom: '1px solid #f1f5f9' },
  tableTd: { padding: '13px 14px', color: '#475569', fontSize: '13px', verticalAlign: 'middle', whiteSpace: 'nowrap' },
  noDataTd: { padding: '40px 14px', textAlign: 'center', color: '#94a3b8', fontSize: '14px', fontWeight: '500' },
  termLabel: {
    background: '#eff6ff',
    border: '1px solid #bfdbfe',
    color: '#1e40af',
    padding: '3px 8px',
    borderRadius: '6px',
    fontSize: '11.5px',
    fontWeight: '700',
  },
  statusPill: { padding: '4px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: '700', display: 'inline-block' },
  statusSubmitted: { background: '#fef3c7', color: '#92400e' },
  statusVerified: { background: '#e0e7ff', color: '#3730a3' },
  statusApproved: { background: '#d1fae5', color: '#065f46' },
  actionIconButton: {
    background: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    padding: '6px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paginationDock: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '12px',
    marginTop: '16px',
    paddingTop: '12px',
    borderTop: '1px solid #edf2f7',
  },
  pageIndicator: { fontSize: '13px', color: '#475569' },
  pageBtn: {
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    padding: '6px 14px',
    color: '#334155',
    fontSize: '12.5px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  pageBtnDisabled: { background: '#f8fafc', color: '#94a3b8', cursor: 'not-allowed', borderColor: '#e2e8f0' },
  
  // Modals
  modalBackdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(15, 23, 42, 0.45)',
    backdropFilter: 'blur(6px)',
    zIndex: 2000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  modalWrapperCard: {
    background: '#ffffff',
    borderRadius: '20px',
    width: '100%',
    maxWidth: '680px',
    maxHeight: '90vh',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingBottom: '14px',
    borderBottom: '1px solid #e2e8f0',
  },
  modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
  modalFormBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '14px',
    overflowY: 'auto',
    paddingRight: '4px'
  },
  modalBodyScroll: { overflowY: 'auto', marginTop: '14px', paddingRight: '4px' },
  formSplitGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  fieldContainer: { display: 'flex', flexDirection: 'column', gap: '4px' },
  fieldLabel: { color: '#64748b', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.4px' },
  formInput: {
    width: '100%',
    padding: '9px 12px',
    background: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    color: '#0f172a',
    fontSize: '13px',
    outline: 'none',
    boxSizing: 'border-box'
  },
  formSelect: {
    width: '100%',
    padding: '9px 12px',
    background: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    color: '#0f172a',
    fontSize: '13px',
    outline: 'none',
    boxSizing: 'border-box'
  },
  
  // Student Picker Styles
  studentSearchPickerBox: {
    background: '#f8fafc',
    border: '1px solid #cbd5e1',
    borderRadius: '12px',
    padding: '12px 14px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  inputWithIconBox: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  inlineSearchIcon: {
    position: 'absolute',
    left: '12px',
    color: '#94a3b8'
  },
  fieldInputWithIcon: {
    width: '100%',
    padding: '10px 36px 10px 36px',
    background: '#ffffff',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    color: '#0f172a',
    fontSize: '13px',
    outline: 'none',
    boxSizing: 'border-box'
  },
  pickerClearBtn: {
    position: 'absolute',
    right: '12px',
    background: 'transparent',
    border: 'none',
    color: '#64748b',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '700'
  },
  studentSearchResultsDropdown: {
    position: 'absolute',
    top: '46px',
    left: 0,
    right: 0,
    background: '#ffffff',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    maxHeight: '220px',
    overflowY: 'auto',
    zIndex: 100,
    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.15)'
  },
  candidateResultItem: {
    padding: '10px 14px',
    borderBottom: '1px solid #f1f5f9',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    transition: 'background 0.15s ease'
  },
  univPill: {
    background: '#eff6ff',
    border: '1px solid #bfdbfe',
    color: '#1e40af',
    padding: '2px 8px',
    borderRadius: '6px',
    fontSize: '11px',
    fontWeight: '700'
  },
  
  // Course Choices & Papers Checklist
  coursePillsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginTop: '2px'
  },
  courseToggleChip: {
    border: '1px solid',
    borderRadius: '8px',
    padding: '7px 14px',
    fontSize: '12.5px',
    fontWeight: '700',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    display: 'inline-flex',
    alignItems: 'center'
  },
  checkboxPillsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    marginTop: '2px'
  },
  semesterToggleChip: {
    border: '1px solid',
    borderRadius: '8px',
    padding: '6px 12px',
    fontSize: '12px',
    fontWeight: '700',
    cursor: 'pointer',
    transition: 'all 0.15s ease'
  },
  linkButton: {
    background: 'transparent',
    border: 'none',
    color: '#2563eb',
    fontSize: '11.5px',
    fontWeight: '700',
    cursor: 'pointer'
  },
  papersCardDeck: {
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    maxHeight: '160px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    padding: '6px',
    background: '#f8fafc'
  },
  paperCheckRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 10px',
    borderRadius: '6px',
    border: '1px solid',
    cursor: 'pointer'
  },
  paperSemBadge: {
    fontSize: '10.5px',
    fontWeight: '700',
    color: '#64748b',
    background: '#f1f5f9',
    padding: '2px 6px',
    borderRadius: '4px'
  },
  papersSummaryHighlightCard: {
    background: '#eff6ff',
    border: '1px solid #bfdbfe',
    borderRadius: '12px',
    padding: '12px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '4px'
  },
  selectedCountBadgeBox: {
    background: '#ffffff',
    border: '1px solid #bfdbfe',
    borderRadius: '8px',
    padding: '4px 14px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  formActionDock: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '10px',
    paddingTop: '12px',
    borderTop: '1px solid #e2e8f0'
  },
  formCancelBtn: {
    background: '#f8fafc',
    border: '1px solid #e2e8f0',
    color: '#64748b',
    padding: '9px 16px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  formSaveBtn: {
    background: '#2563eb',
    border: 'none',
    color: '#ffffff',
    padding: '9px 18px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '700',
    cursor: 'pointer'
  },

  // View Modal Styles
  applicantInfoBanner: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px',
    background: '#f8fafc',
    borderRadius: '12px',
    padding: '14px',
    border: '1px solid #e2e8f0',
  },
  infoCol: { display: 'flex', flexDirection: 'column' },
  infoLabel: { fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase' },
  infoValue: { fontSize: '13px', fontWeight: '700', color: '#0f172a', marginTop: '2px' },
  courseMetaBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#eff6ff',
    border: '1px solid #bfdbfe',
    borderRadius: '12px',
    padding: '12px 14px',
    marginTop: '12px',
  },
  remarksBox: {
    background: '#ffffff',
    borderRadius: '10px',
    padding: '12px',
    border: '1px solid #e2e8f0',
    marginTop: '12px',
  },
  subjectsTableWrapper: {
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    overflow: 'hidden',
    marginTop: '8px',
  },
  subTh: { padding: '8px 12px', textAlign: 'left', fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase' },
  modalActionDock: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '20px',
    paddingTop: '14px',
    borderTop: '1px solid #e2e8f0',
  },
  modalCloseBtn: {
    background: '#2563eb',
    border: 'none',
    color: '#ffffff',
    padding: '8px 18px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '700',
    cursor: 'pointer',
  }
};